import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
  export class BonoContratacionTemporadaService {
    private apiUrl: string ='';
    private apiUrlGetBonoContratacion: string ='';
    private apiUrlGetBonoContratacionDisp: string='';
    private apiUrlAuthBonoContratacion: string = '';
    private apiUrlPutBonoContratacion: string='';
    private apiUrlPostBonoContratacion: string ='';
    private apiUrlEliminarBono: string ='';
    private apiUrlObtenerChoferes:string='';
    private apiUrlDispChofer:string='';
    private apiUrlrpt:string='';
    private apiUrlrptTodos:string='';
    constructor(private _http: HttpClient) {
        this.apiUrlGetBonoContratacion = environment.sUrlNomina + 'BonoContratacionTemporada/BonoConTemp';
        this.apiUrlGetBonoContratacionDisp = environment.sUrlNomina + 'BonoContratacionTemporada/BonoConTempDisp';
        this.apiUrlObtenerChoferes=environment.sUrlNomina+'BonoContratacionTemporada/BonoListaChoferes';
        this.apiUrlPostBonoContratacion = environment.sUrlNomina + 'BonoContratacionTemporada/GuardaBonoConTempDisp';
        this.apiUrlPutBonoContratacion = environment.sUrlNomina + 'BonoContratacionTemporada/ActualizaBonoConTempDisp';
        this.apiUrlEliminarBono = environment.sUrlNomina + 'BonoContratacionTemporada/EliminaBonoConTemp';
        this.apiUrlAuthBonoContratacion = environment.sUrlNomina + 'BonoContratacionTemporada/AutorizaBonoConTempDisp';
        this.apiUrlDispChofer=environment.sUrlNomina+'BonoContratacionTemporada/DispChofer';
        this.apiUrlrpt=environment.sUrlNomina+'BonoContratacionTemporada/rptBonoConTemp';
        this.apiUrlrptTodos=environment.sUrlNomina+'BonoContratacionTemporada/rptTodosBonosConTemp';
    }

    getBonoPorSemanayCiudad(id_semana:number,anio:number,id_ciudad_principal_hm:number, cod_usuario: string): Observable<any[]> {
        const valores = {
          params: new HttpParams().
            set('num_anio', anio).
            set('id_semana', id_semana).
            set('id_ciudad_principal', id_ciudad_principal_hm).
            set('cod_usuario', cod_usuario)

        };
        return this._http.get<any[]>(this.apiUrlGetBonoContratacion, valores).pipe(retry(1), catchError(this.handleError));
    }
    getListChoferesContrTemporada(id_semana:number,anio:number,id_ciudad_principal_hm:number): Observable<any[]> {
        const valores = {
          params: new HttpParams().
            set('num_anio', anio).
            set('id_semana', id_semana).
            set('id_ciudad_principal', id_ciudad_principal_hm)

        };
        return this._http.get<any[]>(this.apiUrlObtenerChoferes, valores).pipe(retry(1), catchError(this.handleError));
    }

    getListDispersion(id_semana: number,anio:number,clv_disp:number, fec_ingreso:string): Observable<any[]> {
        const valores = {
            params: new HttpParams().
                set('id_semana',id_semana).
                set('num_anio',anio).
                set('clv_disp',clv_disp).
                set('fecha_ingreso',fec_ingreso)
        }
        return this._http
            .get<any[]>(this.apiUrlGetBonoContratacionDisp,valores)
            .pipe(retry(1), catchError(this.handleError));
    }

    PostBonoContratacion(data:any[]):Observable<any>{
        const headers = { 'content-type': 'application/json'}
        return this._http.post<any>(this.apiUrlPostBonoContratacion,data,{headers})
        .pipe(retry(1), catchError(this.handleError));
    }

    PutBonoContratacion(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}
        return this._http.put<any>(this.apiUrlPutBonoContratacion,data,{headers})
        .pipe(retry(1), catchError(this.handleError));
    }

    AuthBonoContratacion(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}
        return this._http.put<any>(this.apiUrlAuthBonoContratacion,data,{headers})
        .pipe(retry(1), catchError(this.handleError));
    }

    DeleteBono(data:any):Observable<any>{
        return this._http.put<any>(this.apiUrlEliminarBono,data).pipe(retry(1), catchError(this.handleError));
    }
    dispColaborador(id_semana: number,num_anio: number,cod_chofer : number): Observable<any> {
        const valores = {
            params: new HttpParams()
            .set('id_semana', id_semana)
            .set('num_anio', num_anio)
            .set('cod_chofer', cod_chofer )
            }

        return this._http
            .get<any>(this.apiUrlDispChofer,valores).pipe(retry(1), catchError(this.handleError));
    }

    rptbono(num_anio: number, id_semana: number,id_ciudad_principalrpt : number): Observable<any[]> {
        const valores = {
            params: new HttpParams()
            .set('num_anio', num_anio)
            .set('id_semana', id_semana)
            .set('id_ciudad_principal', id_ciudad_principalrpt )
            }

        return this._http
            .get<any[]>(this.apiUrlrpt,valores).pipe(retry(1), catchError(this.handleError));
    }
    rptTodosBonos(): Observable<any[]> {
        return this._http
            .get<any[]>(this.apiUrlrptTodos).pipe(retry(1), catchError(this.handleError));
    }

    handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
    }
}
